import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { SearchField } from './SearchField.tsx';
import { useSearchResults } from './useSearchResults.tsx';

import { useTracking } from '#src/hooks/tracking/TrackingProvider.tsx';

export const SiteSearch = ({
  inline,
  onForceOpen,
}: {
  inline?: boolean;
  onForceOpen?: () => void;
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { trackLink } = useTracking();

  const [searchTerm, setSearchTerm] = useState('');
  const { data: results, isLoading, isError } = useSearchResults(searchTerm);

  return (
    <SearchField
      inline={inline}
      onForceOpen={onForceOpen}
      onChooseResult={(result) => {
        const url = `${result.path}${location.search}`;
        trackLink({
          eventName: 'developer_site_search_succeeded',
          data: {
            searchString: searchTerm,
          },
        });
        navigate(url);
        setSearchTerm('');
      }}
      onSearchTermChange={setSearchTerm}
      results={results ?? []}
      searchTerm={searchTerm}
      isLoading={isLoading}
      isError={isError}
    />
  );
};
